/**
 * dds-product-v2-price.js
 * JS pentru: ajustare font titlu/subtitle, toggle acordeon,
 * preț dinamic (qty, discount, transport), cart total tracking.
 * Extras din dds-main-product-v2.liquid pentru modularitate.
 */
(function() {

  /* ── Ajustare automată dimensiune font titlu și subtitle ── */
  function adjustTitleSize() {
    var title = document.querySelector('.dds-v2-title');
    if (title) {
      title.style.fontSize = '';
      var fontSize = parseFloat(window.getComputedStyle(title).fontSize);
      var minFontSize = 14;
      while (title.scrollWidth > title.clientWidth && fontSize > minFontSize) {
        fontSize -= 0.5;
        title.style.fontSize = fontSize + 'px';
      }
    }

    var sub = document.querySelector('.dds-v2-subtitle');
    if (sub) {
      sub.style.fontSize = '';
      var subFontSize = parseFloat(window.getComputedStyle(sub).fontSize);
      var minSubFontSize = 10;
      while (sub.scrollWidth > sub.clientWidth && subFontSize > minSubFontSize) {
        subFontSize -= 0.5;
        sub.style.fontSize = subFontSize + 'px';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adjustTitleSize);
  } else {
    adjustTitleSize();
  }
  window.addEventListener('load', adjustTitleSize);
  window.addEventListener('resize', adjustTitleSize);

  /* ── Elimină eroarea de form Dawn ── */
  function removeProductFormError() {
    var pf = document.getElementById('dds-v2-add-form');
    if (!pf) return;
    var wrapper = pf.closest('product-form');
    if (!wrapper) return;
    var errDiv = wrapper.querySelector('.product-form__error-message-wrapper');
    if (errDiv) { errDiv.style.cssText = 'display:none!important;height:0!important;margin:0!important;padding:0!important;'; }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeProductFormError);
  } else {
    removeProductFormError();
  }
  setTimeout(removeProductFormError, 500);

  /* ── Reset cantitate după add-to-cart AJAX ── */
  var pForm = document.getElementById('dds-v2-add-form');
  if (pForm) {
    pForm.addEventListener('submit', function() {
      var isBundle = !!document.querySelector('.dds-bsel');
      if (isBundle) return; /* Bundle selector manages its own qty */
      var btn = pForm.querySelector('button[type="submit"]');
      var check = setInterval(function() {
        if (btn && !btn.classList.contains('loading')) {
          clearInterval(check);
          var inp = document.getElementById('v2-qty-inp');
          if (inp && inp.value !== "1") {
            inp.value = 1;
            if (typeof window.ddsV2UpdatePrice === 'function') window.ddsV2UpdatePrice();
          }
        }
      }, 400);
    });
  }

})();

/* ── Toggle acordeon ── */
window.ddsToggleAcc = function(header) {
  var block = header.closest('.dds-v2-acc-block');
  if (!block) return;
  var isOpen = block.classList.contains('is-open');

  document.querySelectorAll('.dds-v2-acc-block').forEach(function(b) {
    b.classList.remove('is-open');
  });

  if (!isOpen) {
    block.classList.add('is-open');
    setTimeout(function() {
      var y = header.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }, 200);
  }
};

/* ── Preț dinamic (qty, reducere 5% la 6+, transport, quick form) ── */
window.ddsV2UpdatePrice = function() {
  var qty = parseInt(document.getElementById('v2-qty-inp').value) || 1;
  var isTrio = !!window.ddsIsTrio;
  var trioMult = isTrio ? (parseInt(window.ddsTrioCompQty) || 3) : 1;
  var effectiveQty = qty * trioMult;

  var trioCartInp = document.getElementById('v2-trio-cart-qty');
  if (trioCartInp) trioCartInp.value = effectiveQty;

  // Sync cantitate pentru Apple/Google Pay
  var dynQty = document.getElementById('dds-v2-dynamic-qty');
  if (dynQty) dynQty.value = trioCartInp ? effectiveQty : qty;

  var priceEl = document.getElementById('dds-v2-price-main');
  var compareEl = document.getElementById('dds-v2-price-old');

  var currentPrice = 0;
  var compareTotal = 0;
  var displayDiscount = false;

  if (priceEl && priceEl.dataset.basePrice) {
    var bp = parseInt(priceEl.dataset.basePrice) / 100;
    currentPrice = bp * qty;
    var isBundle = !!document.querySelector('.dds-bsel');
    var isPackage = !!window.ddsIsPackage || (window.location.pathname.indexOf('pachet') !== -1) || (window.location.pathname.indexOf('3x') !== -1);
    if (isBundle) {
      var selectedRow = document.querySelector('.dds-bsel__row.is-selected');
      if (selectedRow) {
        currentPrice = (parseInt(selectedRow.dataset.price) || 0) / 100;
        compareTotal = (parseInt(selectedRow.dataset.compare) || 0) / 100;
        displayDiscount = compareTotal > currentPrice;
      }
    } else if (isTrio || (!isBundle && !isPackage)) {
      if (effectiveQty >= 8) {
        currentPrice = currentPrice * 0.85;
        displayDiscount = true;
      } else if (effectiveQty >= 4) {
        currentPrice = currentPrice * 0.95;
        displayDiscount = true;
      }
    }
    priceEl.innerText = currentPrice.toFixed(2).replace('.', ',') + ' Lei';
  }
  if (compareEl && compareEl.dataset.baseCompare) {
    var isBundle = !!document.querySelector('.dds-bsel');
    if (!isBundle) {
      var cp = parseInt(compareEl.dataset.baseCompare) / 100;
      compareTotal = cp * qty;
    }
    compareEl.innerText = compareTotal.toFixed(2).replace('.', ',') + ' Lei';
  }

  var discEl = document.getElementById('dds-v2-price-disc');
  var shipBadge = document.getElementById('dds-v2-shipping-badge');
  var discWrapper = document.getElementById('dds-v2-price-disc-wrapper');
  var shipSavings = currentPrice >= 139 ? 15 : 0;

  var saved = 0;
  if (isBundle || isPackage) {
    /* Bundle & Pachete: doar diferența de preț, fără transport inclus în badge */
    if (compareTotal > currentPrice && currentPrice > 0) {
      saved = compareTotal - currentPrice;
    }
  } else {
    /* Produs normal: include și transport savings */
    if (compareTotal > currentPrice && currentPrice > 0) {
      saved = (compareTotal - currentPrice) + shipSavings;
    } else if (qty >= 8 && currentPrice > 0) {
      saved = (bp * qty * 0.15) + shipSavings;
    } else if (qty >= 4 && currentPrice > 0) {
      saved = (bp * qty * 0.05) + shipSavings;
    } else if (shipSavings > 0) {
      saved = shipSavings;
    }
  }

  if (!isBundle) {
    if (discEl) {
      if (saved > 0) {
        discEl.innerText = 'Economisești ' + saved.toFixed(2).replace('.', ',') + ' Lei';
        discEl.style.display = 'inline-block';
      } else {
        discEl.style.display = 'none';
      }
    }

    var cartTotal = parseFloat(window.ddsCartTotal || 0) / 100;
    var totalForShipping = currentPrice + cartTotal;

    if (shipBadge) {
      shipBadge.style.display = totalForShipping >= 139 ? 'inline-flex' : 'none';
    }

    if (discWrapper) {
      discWrapper.style.display = (saved > 0 || totalForShipping >= 139) ? 'flex' : 'none';
    }
  }

  // Update pills zile cură
  var daysEl = document.getElementById('dds-v2-days-pill');
  if (daysEl && daysEl.dataset.baseDays) {
    var baseDays = parseInt(daysEl.dataset.baseDays);
    if (!isNaN(baseDays) && baseDays > 0) {
      var totalDays = baseDays * qty;
      var suffix = totalDays >= 20 ? ' de zile' : ' zile';
      daysEl.innerText = 'Pentru ' + totalDays + suffix;
    }
  }

  // Update subtitle capsule count dynamically when qty changes
  var subtitleEl = document.querySelector('.dds-v2-subtitle');
  if (subtitleEl) {
    var baseCaps = parseInt(subtitleEl.dataset.baseCapsules);
    var unit = subtitleEl.dataset.unitateMasura;
    var isBundle = !!document.querySelector('.dds-bsel');
    if (!isBundle && baseCaps && unit) {
      if (/\d/.test(unit)) {
        subtitleEl.textContent = 'Doza de Sănătate, ' + unit;
      } else {
        subtitleEl.textContent = 'Doza de Sănătate, ' + (baseCaps * qty) + ' ' + unit;
      }
    }
  }

  // Update quick form
  var qfInp = document.getElementById('qf-qty-input');
  if (qfInp && parseInt(qfInp.value, 10) !== qty) qfInp.value = qty;
  if (typeof window.ddsQuickUpdateFormNudge === 'function') {
    window.ddsQuickUpdateFormNudge();
  }
  if (typeof window.ddsUpdateQuickFormSummary === 'function') {
    window.ddsUpdateQuickFormSummary();
  }
  var qfEl = document.getElementById('dds-quick-form');
  if (qfEl && qfEl.classList.contains('dds-quick-form--open')) {
    qfEl.style.maxHeight = qfEl.scrollHeight + 'px';
  }
};

/* ── Cart total tracking dinamic ── */
window.ddsRefreshCartTotal = function() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      window.ddsCartTotal = cart.total_price;
      if (typeof window.ddsV2UpdatePrice === 'function') window.ddsV2UpdatePrice();
    })
    .catch(function(err) {
      console.warn('Failed to update ddsCartTotal:', err);
    });
};

if (!window.ddsFetchIntercepted) {
  window.ddsFetchIntercepted = true;
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    return originalFetch.apply(this, args).then(function(response) {
      if (response.ok && typeof args[0] === 'string') {
        var url = args[0];
        if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear') || url.includes('/cart/update')) {
          setTimeout(window.ddsRefreshCartTotal, 300);
        }
      }
      return response;
    });
  };
}

// Inițializare
if (typeof window.ddsV2UpdatePrice === 'function') {
  window.ddsV2UpdatePrice();
}
